import { useEffect, useRef } from 'react'
import styled from 'styled-components'
import cx from 'classnames'
import isNil from 'lodash/isNil'
import Text from '@components/Text'
import getRandomString from '@utils/getRandomString'
import { AccordionId } from './types'

// interface AccordionItemProps {
//   title: string;
//   activeId: AccordionId;
//   onClick: (id: string) => void;
// }

const Title = styled(Text)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-family: Campton;
  font-weight: 500;
  letter-spacing: -0.1rem;
  text-align: left;
  width: 100%;
  padding: 2.4rem 0;
  cursor: pointer;
  background: none;
  border: none;
  outline: none;
`

export const Content = styled.div`
  overflow: hidden;
  transition: height 0.4s cubic-bezier(0.17, 0.84, 0.44, 1);
`

const ContentInner = styled.div`
  padding: 0 0 3.2rem;
  opacity: 0;
  transform: translateY(2rem);
  transition: 0.3s cubic-bezier(0.17, 0.84, 0.44, 1);
  transition-property: transform, opacity;

  > * {
    margin: 0 0 2.4rem;

    &:last-child {
      margin: 0;
    }
  }
`

const Plus = styled.span`
  position: relative;
  display: inline-block;
  width: 1.2rem;
  height: 1.2rem;
  pointer-events: none;
  margin-left: 1.6rem;
  transition: transform 0.3s cubic-bezier(0.17, 0.84, 0.44, 1);
  transform-origin: center;
  transform: rotate(90deg);

  &::before {
  }

  &::after,
  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 0;
    width: 100%;
    height: 0.2rem;
    background-color: currentColor;
    transition: transform 0.3s cubic-bezier(0.17, 0.84, 0.44, 1);
  }

  &::after {
    transform: translateY(-50%);
  }

  &::before {
    transform: translateY(-50%) rotate(90deg);
    transform-origin: center;
  }
`

const Item = styled.li`
  &.is-active {
    ${ContentInner} {
      opacity: 1;
      transform: none;
    }

    ${Plus} {
      transform: rotate(0deg);

      &::before {
        transform: translateY(-50%) rotate(0);
      }
    }
  }
`

// TODO: fix any
const AccordionItem: React.FC<any> = ({
  title,
  children,
  onClick,
  activeId,
  ...props
}) => {
  const id = useRef<AccordionId>(getRandomString())
  const innerContainerElement = useRef<HTMLDivElement>(null)
  const containerElement = useRef<HTMLDivElement>(null)
  const isActive = id.current === activeId

  useEffect(() => {
    if (!isNil(innerContainerElement) && !isNil(containerElement)) {
      const inner = innerContainerElement.current as HTMLDivElement
      const outer = containerElement.current as HTMLDivElement

      if (isActive) {
        outer.style.height = `${inner.getBoundingClientRect().height}px`
      } else {
        outer.style.height = '0px'
      }
    }
  }, [activeId])

  return (
    <Item {...props} className={cx({ 'is-active': isActive })}>
      <Title
        onClick={() => onClick(id.current)}
        as="button"
        type="button"
        size="large"
      >
        {title}
        <Plus />
      </Title>
      <Content ref={containerElement}>
        <ContentInner ref={innerContainerElement}>{children}</ContentInner>
      </Content>
    </Item>
  )
}

export default AccordionItem
